// 傳入state陣列或單一state皆可，若是傳入陣列，要注意state和value位置一致

export default function({states, newValues, parentThis, cb}) {
  let stateObj = {},
      isArray = states.constructor.toString().indexOf('Array');
  if(isArray !== -1){
    let len = states.length;
    for (let i = 0 ; i < len ; i++){
        stateObj[states[i]] = newValues[i];
    }
  }else {
    stateObj[states] = newValues;
  }
  
  parentThis.setState(stateObj, cb);
}


// WEBPACK FOOTER //
// ./src/commonJS/parentStateHandler.js